/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-one-expression-per-line */
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import React, { useState } from 'react';
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Alert,
} from 'reactstrap';
import { UPDATE_LOVEBOX_EMAIL_PHOTOBOOK } from '../../mutation/mutation';
import { GET_ADMIN_USER_BOX_PHOTOBOOK, GET_POTENTIAL_ADMIN_USER_BOX_PHOTOBOOK } from '../../query/query';
import { PhotoBookAdminForm } from '../sav-lovebox/form/photobook-admin-form';
import { PhotoBookEmailAccountSearch } from '../sav-lovebox/form/photobook-email-account';
import { CustomerModal } from '../sav-lovebox/modal/customer-modal';

const PhotoBookUserDataTable = ({ user, email }) => {
  const boxLinked = user
  && user.boxes
  && user.boxes.find((b) => (b && b.isAdmin && b.photoBook && b.photoBook.contractId));

  return (
    <Container>
      <Row>
        <Col>
          <div>
            <div>
              <b>Name:</b> {user.firstname}
            </div>
            <div>
              <b>Email:</b> {email}
            </div>
            <div>
              <b>Account linked:</b> {boxLinked ? 'Yes' : 'No'}
            </div>
            { boxLinked && (
              <div>
                <div>
                  <b>Admin Lovebox linked Mac address:</b> {boxLinked.macAddress}
                </div>
                <div>
                  <b>Customer email:</b> {user.emails[0].customerAddress}
                </div>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const LinkerHelper = ({ user, email }) => {
  const boxLinked = user
  && user.boxes && user.boxes.find((b) => (b && b.photoBook && b.photoBook.contractId));
  const [macAddress, setMacAddress] = useState();
  const [emailToChange, setEmailToChange] = useState();
  const [linkAccount, setLinkAccount] = useState();
  const [savUpdateLoveboxEmailPhotobook] = useMutation(UPDATE_LOVEBOX_EMAIL_PHOTOBOOK, { fetchPolicy: 'no-cache' });
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [alertError, setAlertError] = useState(false);

  const {
    loading,
    error,
    data: { savGetPotentialUserAdminBoxPhotoBook: potentialUserData } = {},
  } = useQuery(
    GET_POTENTIAL_ADMIN_USER_BOX_PHOTOBOOK,
    {
      fetchPolicy: 'network-only',
      variables: { email },
    },
  );
  const [
    getAdminUser,
    {
      error: errorMacAddress,
      loading: loadingMacAddress,
      data: { savGetAdminUserBoxPhotoBook: potentialAdminUser } = {},
    }] = useLazyQuery(GET_ADMIN_USER_BOX_PHOTOBOOK,
    {
      fetchPolicy: 'network-only',
    });

  const updateMacAddress = (newMacAddress) => {
    if (newMacAddress) {
      getAdminUser({ variables: { macAddress: newMacAddress } });
      setMacAddress(newMacAddress);
    }
  };

  const linkPhotobookAccount = (customerEmail) => {
    if (customerEmail && linkAccount) {
      savUpdateLoveboxEmailPhotobook({
        variables: {
          loveboxEmail: linkAccount,
          customerEmail,
        },
      }).then(() => window.location.reload()).catch(() => {
        setAlertError(true);
      });
    }
  };

  const updateEmailLoveboxAccount = async (newEmail) => {
    if (newEmail) {
      setEmailToChange(newEmail);
      savUpdateLoveboxEmailPhotobook({
        variables: {
          loveboxEmail: newEmail,
          customerEmail: user.emails[0].customerAddress,
          previousLoveboxEmail: email,
        },
      }).then(() => {
        window.location.reload();
      }).catch(() => {
        setAlertError(true);
      });
    }
  };

  const toggleCustomerEmailCheck = (userEmail) => {
    setLinkAccount(userEmail);
    toggle();
  };

  if (loading || loadingMacAddress) {
    return <p>Loading...</p>;
  }

  if (errorMacAddress || error) {
    return <p>Error.</p>;
  }

  return (
    <Container>
      <Row>
        <Col>
          { !boxLinked ? (
            <div>
              <b>Potential email:</b> {potentialUserData ? potentialUserData.emails[0].address : 'No results found'}
              <br />
              { potentialUserData && (
                <Button
                  onClick={() => { toggleCustomerEmailCheck(potentialUserData.emails[0].address); }}
                  color="success"
                  size="xs"
                  style={{ marginBottom: 10 }}
                >
                  Link that account
                </Button>
              )}
              <PhotoBookEmailAccountSearch
                macAddress={macAddress}
                onButtonClick={updateMacAddress}
              />
              { potentialAdminUser && (
                <div>
                  <b>Admin account found:</b> { potentialAdminUser && potentialAdminUser.emails && potentialAdminUser.emails[0] ? potentialAdminUser.emails[0].address : 'No account found' }
                  <br />
                  { potentialAdminUser
                    && potentialAdminUser.emails && potentialAdminUser.emails[0] && (
                    <Button
                      onClick={() => {
                        toggleCustomerEmailCheck(potentialAdminUser.emails[0].address);
                      }}
                      color="success"
                      size="xs"
                    >
                      Link that account
                    </Button>
                  )}
                </div>
              )}
              { alertError && <Alert color="danger"> Error updating Lovebox account</Alert> }
              <CustomerModal modal={modal} toggle={toggle} onButtonClick={linkPhotobookAccount} />
            </div>
          ) : (
            <div>
              <b>Account already linked.</b>
              <br />
              <PhotoBookAdminForm
                email={emailToChange}
                onButtonClick={updateEmailLoveboxAccount}
              />
              { alertError && <Alert color="danger"> Error updating Lovebox account</Alert> }
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

const PhotoBookUserData = ({ userData, email }) => (
  <Container>
    <Card>
      <CardBody>
        <CardTitle>
          User data
        </CardTitle>
        <PhotoBookUserDataTable email={email} user={userData} />
      </CardBody>
    </Card>
    <Card>
      <CardBody>
        <CardTitle>
          Linker Helper
        </CardTitle>
        <LinkerHelper user={userData} email={email} />
      </CardBody>
    </Card>
  </Container>
);

export default PhotoBookUserData;



// WEBPACK FOOTER //
// ./src/components/photobook/user-photobook-data.js